var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.2 18v-7.1h2.4l.36-2.8H11.2V6.3c0-.8.22-1.35 1.38-1.35h1.47V2.46a19.7 19.7 0 0 0-2.15-.11c-2.12 0-3.57 1.3-3.57 3.67V8.1H5.94v2.8h2.39V18h2.87Z",
  fill: "white"
})));
export default SvgFacebook;